import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
// Assets
import HeaderImage from "../../assets/img/header-img.png";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

export default function Header() {
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
      <meta name="google-site-verification" content="gHNTatgjeTO0H6ZRhuLCu0rlyzlSteXsgi8oRVrLXSA" />
      <meta name="keywords" content="Finechek, medical diagnostics, diagnostic solutions, blood analyzers, Finechek BGA-100, Finechek BCA-100, hemoglobin testing, healthcare technology, lab equipment, Sofstyle Ultra" />
      <meta name="description" content="Finechek provides innovative diagnostic solutions, including the Finechek BCA-100, Finechek BGA 100, Hemoglobin Testing System, and other healthcare products for accurate and efficient medical diagnostics." />
        <div>
          <h1 className="font40 extraBold">
            Leading the Way in Diagnostic Excellence.
          </h1>
          <HeaderP className="font10 semiBold">
            Finechek Africa Systems endeavors to offer her client a comprehensive
            range of diagnostic products.<br />
            Introducing the all-new FineChek BCA-100. Experience cutting-edge technology,
            exclusive features, and unmatched performance like never before!
          </HeaderP>
          <BtnWrapper>
            <a 
            href="/products/Finechek BCA 100/Finecheck BCA 100 bronchure.pdf" 
            target="_blank" 
            rel="noopener noreferrer">
              <FullButton title="Finechek BCA-100 Brochure" />
            </a>
          </BtnWrapper>
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Img 
          className="radius8" 
          src={HeaderImage} 
          alt="Finecheck BCA-100" 
          style={{zIndex: 9}} 
          />
          <QuoteWrapper className="flexCenter darkBg radius8">
            <QuotesWrapper>
              <QuotesIcon />
            </QuotesWrapper>
            <div>
              <p className="font15 whiteColor">
              <em>
                Built-in touch screen user-friendly interface.
                <br />
                Automatic sampling probe liquid level detection collision protection.
              </em>
              </p>
              <p className="font13 orangeColor textRight" style={{marginTop: '10px'}}></p>
            </div>
          </QuoteWrapper>
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
  );
}


const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;
const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;


